import React from 'react';
import PropTypes from 'prop-types';
import './Checkbox.css';

const Checkbox = ({ text, subText, checked, onChange, id }) => {
  return (
    <label htmlFor={id} className="Checkbox-label">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="Checkbox-input"
      />
      <span className="Checkbox-custom"></span>
      <span className="Checkbox-label-texts">
        <span className="Checkbox-text">{text}</span>
        {subText && <span className="Checkbox-subtext">{subText}</span>}
      </span>
    </label>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  subText: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Checkbox;
